import { t } from "@lingui/macro";
import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TBodyCell,
  THeaderCell,
  Badge,
} from "@reactive-resume/ui";
import { WithdrawalWithUser } from "libs/dto/src/withdrawal";

export const WithdrawalTable: React.FC<{ data?: WithdrawalWithUser[] }> = ({ data = [] }) => {
  const titleHeader: string[] = ["Reference", "Emission", "Validation", t`Montant`, t`Statut`];

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "accepted":
        return <Badge variant="success">Accepté</Badge>;
      case "rejected":
        return <Badge variant="error">Rejeté</Badge>;
      case "pending":
        return <Badge variant="warning">En attente</Badge>;
      default:
        return <Badge variant="secondary">{status}</Badge>;
    }
  };
  return (
    <>
      <Table className="my-2 md:w-[800px] lg:w-full">
        <TableHeader variant="AmbaTable" className="text-foreground font-bold">
          <TableRow>
            {titleHeader.map((item) => {
              return (
                <THeaderCell
                  className="p-4 text-left text-base font-bold font-medium md:text-lg"
                  text={item}
                />
              );
            })}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item) => {
            return (
              <TableRow className="bg-block/50 hover:bg-background">
                <TBodyCell className="p-4 text-left font-medium">{item.reference}</TBodyCell>
                <TBodyCell className="p-4 text-left font-medium">
                  {new Date(item.demandDate).toLocaleDateString()}
                </TBodyCell>
                <TBodyCell className="p-4 text-left font-medium">
                  {item.decisionDate ? new Date(item.decisionDate).toLocaleDateString() : "/"}
                </TBodyCell>
                <TBodyCell className="p-4 text-left font-medium">{item.amount}</TBodyCell>
                <TBodyCell className="p-4 text-left font-medium">
                  {getStatusBadge(item.status)}
                </TBodyCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};
